import { render, staticRenderFns } from "./CreatePlantFormDialog.vue?vue&type=template&id=2d4c6a19&"
import script from "./CreatePlantFormDialog.vue?vue&type=script&lang=ts&"
export * from "./CreatePlantFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports